<div class="finance-cost-trimester-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="costs()"></grid-content>
</div>